// extracted by mini-css-extract-plugin
export default {"bannerArea":"banner-component_bannerArea__tldef"};